const gameScoringPointsLogicEnum = Object.freeze({
  basic: 'Gamification_ScoringForm_PointsLogic_Standard',
  advancement_multiplier:
    'Gamification_ScoringForm_PointsLogic_AdvancementMultiplier',
  odds_multiplier: 'Gamification_ScoringForm_PointsLogic_OddsMultiplier'
})

export { gameScoringPointsLogicEnum }



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/GameScoringPointsLogicEnum.js